import { useCallback, useEffect, useState } from "react";

export const MP_PLANNING_IMMERSIVE_BODY_CLASS = "mp-planning-immersive";

export function usePlanningFullscreen(options?: { blockEscapeExit?: boolean }) {
  const [fullscreen, setFullscreen] = useState(false);
  const blockEscapeExit = options?.blockEscapeExit ?? false;

  const exit = useCallback(() => {
    document.body.classList.remove(MP_PLANNING_IMMERSIVE_BODY_CLASS);
    setFullscreen(false);
  }, []);

  const enter = useCallback(() => {
    document.body.classList.add(MP_PLANNING_IMMERSIVE_BODY_CLASS);
    setFullscreen(true);
  }, []);

  const toggle = useCallback(() => {
    if (fullscreen) exit();
    else enter();
  }, [fullscreen, enter, exit]);

  useEffect(() => {
    if (!fullscreen) return;

    function onKeyDown(e: KeyboardEvent) {
      if (e.key !== "Escape" || blockEscapeExit) return;
      e.preventDefault();
      exit();
    }

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [fullscreen, blockEscapeExit, exit]);

  useEffect(() => {
    return () => {
      document.body.classList.remove(MP_PLANNING_IMMERSIVE_BODY_CLASS);
    };
  }, []);

  return { fullscreen, toggle, exit, enter };
}
